import styled from "styled-components";
import { GradientBackground } from "@util-components";

export const RegistrationPage = styled(GradientBackground)`
  text-align: center;

  span {
    color: #ffffff;
    font-family: Raleway;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    display: block;
    padding: 1.5em 0;
  }

  .rocket {
    width: 250px;
    height: 250px;
    text-align: center;
    padding: 40px 0 40px 0;
  }
`;
